import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization owner or team admin, you can remove teams that no longer need access to a set of packages governed by your organization. Removing the team will not remove the team members or packages from your organization.`}</p>
    <Note mdxType="Note">
      <><strong>Note:</strong> if you remove all teams referencing a particular package, it will be orphaned and you will lose access to it. If this happens, {shared['contact-support'].text}.</>
    </Note>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-teams-tab'].text}</>
        <>{shared['organization-teams-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Beside the name of the team you want to remove, click `}<strong parentName="p">{`X`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-remove.png" alt="Screenshot of the remove team button" mdxType="Screenshot" />
      </li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` You cannot remove the developers team, `}<a parentName="p" {...{
          "href": "/about-developers-team"
        }}>{`learn more about the developers team`}</a>{`.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      